import React from 'react';

import { Combobox, ComboboxOptionProps, Group } from '@mantine/core';

type Props = ComboboxOptionProps & {
    rightSection?: React.ReactNode;
};

export const ComboboxOption = ({ rightSection, children, ...otherProps }: Props) => {
    return (
        <Combobox.Option {...otherProps}>
            <Group justify="space-between">
                {children}
                {rightSection}
            </Group>
        </Combobox.Option>
    );
};
